import { addDays, isAfter, parseISO } from 'date-fns'
import { defineStore } from 'pinia'

const COUPON_EXPIRATION_IN_DAYS = 7

export const useHypeStore = defineStore(
  'ltc_hype',
  () => {
    const couponCode = ref<Maybe<string>>(null)
    const couponDate = ref<Maybe<string>>(null)
    const couponSeen = ref(false)

    const deleteCoupon = () => {
      couponCode.value = null
      couponDate.value = null
      couponSeen.value = false
    }

    const setCoupon = (newCoupon: string) => {
      couponCode.value = newCoupon
      couponDate.value = new Date().toISOString()
      couponSeen.value = false
    }

    const setCouponSeen = (isSeen: boolean) => {
      couponSeen.value = isSeen
    }

    const checkCouponExpiration = () => {
      if (!couponDate.value) return

      const expirationDate = addDays(new Date(), COUPON_EXPIRATION_IN_DAYS)

      if (isAfter(parseISO(couponDate.value), expirationDate)) {
        deleteCoupon()
      }
    }

    onBeforeMount(() => {
      checkCouponExpiration()
    })

    return {
      checkCouponExpiration,
      couponCode,
      couponDate,
      couponSeen,
      deleteCoupon,
      setCoupon,
      setCouponSeen,
    }
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
